<template>
    <div>

        <template v-if="!ver_fila">

            <div class="card dashcard mb-0">
                <div class="card-body">

                <div class="form-row">
                    <div class="col col-12 col-md-3">
                        <div class="input-group mb-1" id="data-de-atendimento">
                            <div class="input-group-prepend">
                                <button type="button" class="btn btn-outline-primary" @click="load()" :disabled="$store.state.loading">
                                    <i class="fas fa-sync-alt fa-fw"></i>
                                </button>
                            </div>
                            <input type="date" class="form form-control" v-model="referencia" @change="ativar_rebuscar()">
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Ordenação">
                                    <i class="fa-solid fa-sort mr-1"></i>
                                    <i class="fa-solid fa-m fa-fw mr-1" v-if="tipo_ordem == 'M'"></i>
                                    <i class="fa-solid fa-c fa-fw mr-1" v-if="tipo_ordem == 'C'"></i>
                                    <i class="fa-solid fa-a fa-fw mr-1" v-if="tipo_ordem == 'A'"></i>
                                    <i class="fa-solid fa-dollar-sign fa-fw mr-1" v-if="tipo_ordem == 'G'"></i>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" :class="tipo_ordem == 'P' ? 'active' : ''" href="#" @click.prevent="set_tipo_ordem('P')">Ordem Padrão</a>
                                    <a class="dropdown-item" :class="tipo_ordem == 'M' ? 'active' : ''" href="#" @click.prevent="set_tipo_ordem('M')">Ordem Marcação</a>
                                    <a class="dropdown-item" :class="tipo_ordem == 'C' ? 'active' : ''" href="#" @click.prevent="set_tipo_ordem('C')">Ordem Check-In</a>
                                    <a class="dropdown-item" :class="tipo_ordem == 'A' ? 'active' : ''" href="#" @click.prevent="set_tipo_ordem('A')">Ordem Atendimento</a>
                                    <a class="dropdown-item" :class="tipo_ordem == 'G' ? 'active' : ''" href="#" @click.prevent="set_tipo_ordem('G')" v-if="tem_ordem_pag">Ordem Pagamento</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col col-12" :class="( $store.state.user.telemed_integra || $store.state.user.id_usuario == 1 || $store.state.user.ver_md || ( $store.state.user.id_usuario != 1 && ( !$store.state.user.medico || ( $store.state.user.delegantes_medicos && $store.state.user.delegantes_medicos.length ) ) ) ) ? 'col-md-3' : 'col-md-5'">
                    <div class="input-group mb-1" id="filtro-pesquisar">
                        <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-search fa-fw" v-if="!search || !$store.state.loading"></i>
                            <div class="spinner-grow spinner-grow-sm" role="status" v-else>
                            <span class="sr-only">Loading...</span>
                            </div>
                        </span>
                        </div>
                        <input type="text" class="form form-control" v-model="search" placeholder="Pesquisar..." @input="pesquisar ()">
                        <div class="input-group-append">
                        <button class="btn dropdown-toggle" :class="faixa_hora ? 'btn-secondary' : 'btn-outline-secondary'" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="far fa-clock mr-1" v-if="!faixa_hora"></i>
                            <span v-else class="mr-1">{{ faixa_hora }}</span>
                        </button>
                        <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'M'">Manhã (&lt;13)</a>
                            <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'T'">Tarde (13-18)</a>
                            <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'N'">Noite (&gt;18)</a>
                            <a class="dropdown-item" href="#" @click.prevent="faixa_hora = 'TN'">Tarde/Noite ((&gt;13)</a>
                            <div role="separator" class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click.prevent="faixa_hora = ''">Todos</a>
                        </div>
                        </div>
                        <div class="input-group-append">
                        <router-link :to="{ name: 'cagendas' }" class="btn btn-outline-secondary">
                            <i class="fa-regular fa-calendar-days"></i>
                        </router-link> 
                        </div>
                        <div class="input-group-append">
                        <relatorios-linkados
                            pagina="consultorio"
                            :parms="{ medico: $store.state.user.id_pessoa }"
                            :outros="lista_opcoes_relatorio"
                        />
                        </div>
                        <print-export v-if="false" printid="lista-pacientes" id="botao-de-imprimir" />
                    </div>
                    </div>
                    <div class="col col-12 col-md-4 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example" id="botoes-de-visao" v-if="!is_emergencia">
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'A'; load()">
                        <i class="far fa-calendar-check mr-2"></i>
                        Marcações
                        </button>
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'G' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'G'; load()">
                        <i class="far fa-calendar mr-2"></i>
                        Livres
                        </button>
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="viewMode = 'C'; load()">
                        <i class="fa fa-times mr-2" aria-hidden="true"></i>
                        Cancelados
                        </button>
                    </div>

                    <div class="btn-group mb-1" role="group" aria-label="Basic example" id="botoes-de-visao" v-else>
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="trocar_visao('A')">
                        <i class="fas fa-user mr-2"></i>
                        Meus
                        </button>
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'E' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="trocar_visao('E')">
                        <i class="fas fa-users mr-2"></i>
                        Todos
                        </button>
                        <button type="button" class="btn text-nowrap text-truncate" :class="viewMode == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" 
                        @click="trocar_visao('C')">
                        <i class="fa fa-times mr-2" aria-hidden="true"></i>
                        Cancelados
                        </button>
                    </div>
                    </div>

                    
                    <div class="col col-12 col-md-2 d-flex flex-column" v-if="$store.state.user.id_usuario == 1 || $store.state.user.ver_md">
                    <az-input icon="fas fa-user-md fa-fw" 
                        type="select" 
                        optionsMode="aql"
                        service="medicos.index"
                        optionsName="medicos-cadastro"
                        :optionsParm="{ ativos: true }"
                        optionsData="id_pessoa"
                        v-model="medico_adm" 
                        @input="load ()" />
                    </div>

                    <div class="col col-12 col-md-2 d-flex flex-column" v-else-if="$store.state.user.id_usuario != 1 && ( !$store.state.user.medico || ( $store.state.user.delegantes_medicos && $store.state.user.delegantes_medicos.length ) )">
                    <az-input icon="fas fa-user-md fa-fw" 
                        type="select" 
                        optionsMode="aql"
                        service="medicos.index"
                        :optionsName="'medicos-delegado-' + $store.state.user.id_usuario"
                        :optionsParm="{ ativos: true, delegado: true }"
                        optionsData="id_pessoa"
                        v-model="medico_adm" 
                        @input="load ()" />
                    </div>

                    <div class="col col-12 col-md-2 d-flex flex-column" v-else-if="$store.state.user.telemed_integra">
                    <template v-if="$store.state.user.telemed_integra">
                        <button type="button" class="btn btn-primary text-nowrap text-truncate" @click="telemed_integra()" :disabled="$store.state.loading">
                        <i class="fas fa-users"></i>
                        Verificar Pacientes
                        </button>
                    </template>
                    <template v-else-if="false">
                        <button type="button" class="btn btn-success text-nowrap text-truncate">
                        <i class="fas fa-bell mr-2"></i>
                        Chamar Próximo
                        </button>
                    </template>
                    </div>

                </div>

                <div class="form-row mt-2" v-if="referencia == $util.hoje() && lista_locais.length">
                    <div class="col col-12">
                    <az-input
                        sizing="sm"
                        type="button-group"
                        :optionsList="lista_locais"
                        optionsData="id"
                        v-model="local_item" />
                    </div>
                </div>

                <div class="form-row mt-3 " v-if="lista_classes.length > 2">
                    <div class="col col-12 col-md-3 d-flex flex-column">
                        <div class="btn-group mb-1" role="group" aria-label="Basic example">
                            <button type="button" class="btn btn-sm" :class="viewModeClasse == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewModeClasse = 'A'">
                                Apenas
                            </button>
                            <button type="button" class="btn btn-sm" :class="viewModeClasse == 'E' ? 'btn-secondary' : 'btn-outline-secondary'" @click="viewModeClasse = 'E'">
                                Exceto
                            </button>
                        </div>
                    </div>
                    <div class="col col-12 col-md-9">
                    <az-input
                        class="mb-0"
                        sizing="sm"
                        type="button-group"
                        :optionsList="lista_classes"
                        v-model="classe" />
                    </div>
                </div>

                </div>

            </div>

            <div>
                <span class="badge badge-dark mr-1">
                {{ lista_status.reduce((total, carry) => total + carry.count, 0) }} / Total
                </span>
                <span class="badge mr-1" :class="'badge-' + ( status.color ? status.color : 'secondary' )" v-for="(status, isx) in lista_status" :key="isx">
                {{ status.count }} / {{ status.title }}
                </span>
            </div>

            <div class="progress mt-1 mb-1">
                <div class="indeterminate" v-if="$store.state.loading && !show_empty_state"></div>
                <div class="determinate" v-else></div>
            </div>

            <!-- Tarefas -->
            <div v-if="tarefas && tarefas.length && pode_acao" class="mb-4">
                <div class="card carde mb-2 w3-animate-opacity">
                <div class="card-body p-3 alert-warning">
                    <div class="row">
                    <div class="col col-12 col-md-10">
                        <h5>
                        <span class="badge badge-secondary">{{ tarefas.length }}</span>
                        <small class="ml-2">{{ tarefas.length == 1 ? 'pendência' : 'pendências' }}</small>
                        </h5>
                        <ul class="mb-0">
                        <li v-for="(tarefa, itx) in lista_tarefas" :key="itx">
                            {{ tarefa.st_descricao }}
                        </li>
                        <li v-if="tarefas.length > 2">
                            <span class="badge badge-secondary">
                            <i class="fas fa-ellipsis-h"></i>
                            </span>
                        </li>
                        </ul>
                    </div>
                    <div class="col col-12 col-md-2 text-right">
                        <button type="button" class="btn btn-dark" @click="$router.push({ name: 'tarefas'})">
                        Acessar
                        </button>
                    </div>
                    </div>
                </div>
                </div>
                
            </div>

            <!-- Outros Atendimentos -->
            <div v-if="exibicao_outros && pode_acao" class="mb-4">

                <div class="card carde mb-2 w3-animate-opacity" v-for="(outro, index) in exibicao_outros" :key="index">

                <div class="card-body p-1 pr-2 alert-warning">
                    <div class="row">
                    <!-- Ação -->
                    <div class="col col-12 col-md-2 d-flex flex-column justify-content-center py-1" id="botao-acao" >
                        <div class="btn-group mx-2 my-2 my-md-0" role="group">
                        <button type="button" class="btn btn-sm" :class="'btn-' + acao.color" 
                            v-for="(acao, iax) in outro.acoes" :key="iax"
                            @click="executar_acao_outro(outro, acao)" 
                            :disabled="!acao.id_proxima_etapa || outro.loading">
                            <i :class="acao.titulo" aria-hidden="true" v-if="acao.icon"></i>
                            <span v-else>{{ acao.titulo }}</span>
                        </button>
                        </div>
                    </div>

                    <!-- Hora da Marcação -->
                    <div class="col col-12 col-md-2">
                        <i class="fas fa-clock mr-1"></i>
                        {{ outro.dt_inicio.substr(11,5) }}
                    </div>

                    <!-- Identificação do Paciente -->
                    <div class="col col-12 col-md-4">
                        <template v-if="outro.id_paciente">
                        <celula-dados-paciente :hor="{ marcacao: outro }" />
                        </template>
                        <template v-else>
                        {{ outro.st_nome }}
                        </template>
                        <div class="small text-muted" v-if="outro.usuario && outro.usuario.pessoa">
                        Registrado por: {{ outro.usuario.pessoa.st_nome }}
                        </div>
                    </div>

                    <!-- Observação -->
                    <div class="col col-12 col-md-4">
                        {{ outro.st_observacoes }}
                    </div>

                    </div>
                </div>

                </div>

            </div>

            <!-- Lista de Pacientes -->
            <div id="lista-pacientes">

                <cabecalho-generico titulo="Atendimento Consultório">
                <div>{{ $util.getFormatDate(referencia) }}</div>
                <div v-if="search">Pesquisa: {{ search }}</div>
                </cabecalho-generico>

                <div v-for="(quebra, iq) in exibicao" :key="iq">

                <div class="mt-3 mb-1 d-flex" v-if="iq != ' Lista '"> 
                    <h5 class="mb-0">
                        <a href="#" @click.prevent="toggle_retracao(iq)">
                            <i class="far fa-minus-square mr-2" v-if="!retracao[iq]"></i>
                            <i class="far fa-plus-square mr-2" v-else></i>
                        </a>
                        {{ iq }}
                        <span class="badge badge-secondary">{{ quebra.length }}</span>
                    </h5>
                </div>

                <div v-else-if="false">
                    <span class="badge badge-secondary">{{ quebra.length }}</span>
                </div>

                <template v-if="!retracao[iq]">
                <div class="card carde mb-2 w3-animate-opacity" v-for="(hor, index) in quebra" :key="iq + '-' + index">

                    <div class="card-body p-1 pr-2" :class="( viewMode == 'E' && !para_mim(hor) ) ? 'alert-info' : ( checkStatus(hor).backcolor ? ' alert-' + checkStatus(hor).backcolor : '' )">

                        <div class="row">

                            <!-- Ação -->
                            <div class="col col-12 col-md-2 d-flex flex-column justify-content-center" id="botao-acao">

                            <div class="btn-group mx-2 my-2 my-md-0" role="group">

                                <template v-if="viewMode == 'E' && !para_mim(hor)">
                                <button type="button" class="btn btn-sm btn-secondary px-1 mr-1" 
                                    v-if="hor.marcacao && hor.marcacao.id_atendimento && hor.marcacao.dt_inicio.substr(0,10) == $util.hoje() && hor.marcacao.ch_estado_marcacao == 'A' && checkStatus(hor).complemento" 
                                    :disabled="$store.state.loading || !pode_acao || ( hor.marcacao.item_status && hor.marcacao.item_status.nocons )" @click="incluir_avulso(hor)" title="Incluir registro no atendimento.">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>

                                <button type="button" class="btn btn-sm text-nowrap text-truncate" :class="'btn-' + ( checkStatus(hor).fill ? '' : 'outline-' ) + checkStatus(hor).color"
                                    :disabled="!pode_acao || ( hor && hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.nocons )"
                                    @click="acao_dos_outros(hor)">
                                    {{ checkStatus(hor).title }}
                                </button>
                                </template>

                                <template v-else>

                                <button type="button" class="btn btn-sm btn-outline-secondary px-1 mr-1" 
                                    v-if="config_atende_pre && hor.marcacao && hor.marcacao.dt_inicio.substr(0,10) <= $util.hoje() && hor.marcacao.ch_estado_marcacao == 'A'" 
                                    :disabled="!pode_acao || ( hor.marcacao.item_status && hor.marcacao.item_status.nocons ) || ( hor.loading && hor.marcacao.procedimento && hor.marcacao.procedimento.id_classe_procedimento == 1 )"
                                    @click="anotacoes(hor.marcacao)">
                                    <i class="fas fa-pencil-alt"></i>
                                </button>

                                <button 
                                    type="button" 
                                    :disabled="!pode_acao || hor.loading || ( hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.nocons )"
                                    class="btn btn-sm text-nowrap text-truncate"
                                    :class="'btn-' + ( checkStatus(hor).fill ? '' : 'outline-' ) + checkStatus(hor).color"
                                    @click="checkStatus(hor).action ? checkStatus(hor).action (hor) : ''">
                                    <template v-if="!hor.loading">
                                    <i class="mr-2" :class="checkStatus(hor).icon" v-if="checkStatus(hor).icon"></i> 
                                    </template>
                                    <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                                    <span class="sr-only">Loading...</span>
                                    </div>
                                    {{ checkStatus(hor).title }}
                                </button>

                                </template>

                            </div>

                            <div class="small text-muted text-center" v-if="( hor.marcacao 
                                && hor.marcacao.item_status 
                                && hor.marcacao.item_status.nocons
                                && hor.marcacao.atendimento 
                                && checkStatus(hor).status == 'chamar' )">
                                Executado por Técnico
                            </div>

                            <div class="text-center" v-else-if="hor && hor.marcacao 
                                && hor.marcacao.atendimento && agora
                                && hor.marcacao.atendimento.dt_inicio.substr(0,10) == $util.hoje() 
                                && checkStatus(hor).status == 'chamar'">

                                <span v-if="te_max && te_max < duracao(hor.marcacao.atendimento.dt_inicio, false)" 
                                    class="badge badge-danger">
                                    Esperando {{ duracao(hor.marcacao.atendimento.dt_inicio) }}...
                                </span>
                                <span v-else class="small text-muted" :title="info_campo_ordem(hor)">
                                    Esperando {{ duracao(hor.marcacao.atendimento.dt_inicio) }}...
                                </span>
                            </div>

                            </div>

                            <!-- Hora da Marcação -->
                            <div class="col col-12 col-md-2 d-flex justify-content-center justify-content-md-start">
                                <celula-horarios-marcacao :hor="hor" :emergencia="is_emergencia">
                                <template v-slot:info>
                                    <span v-if="hor 
                                    && hor.marcacao 
                                    && hor.marcacao.id_atendimento 
                                    && hor.marcacao.item_status 
                                    && hor.marcacao.item_status.valor == 'finalizado'
                                    && hor.marcacao.atendimento 
                                    && hor.marcacao.atendimento.atendimento_procedimento
                                    && ( 
                                        hor.marcacao.atendimento.atendimento_procedimento.anamnese === null 
                                        || ( hor.marcacao.atendimento.atendimento_procedimento.anamnese.dt_inclusao && hor.marcacao.atendimento.atendimento_procedimento.anamnese.dt_inclusao == hor.marcacao.atendimento.atendimento_procedimento.anamnese.dt_alteracao )
                                    )
                                    && hor.marcacao.procedimento 
                                    && hor.marcacao.procedimento.id_status_laudo === null">
                                    <i class="fa-solid fa-caret-right mr-1"></i>
                                    </span>
                                </template>
                                </celula-horarios-marcacao>
                            </div>

                            <!-- Identificação do Paciente -->
                            <div class="col col-12 col-md-4" v-if="hor.marcacao">
                                <celula-dados-paciente :hor="hor"
                                :callback_paciente="filtrar_search"
                                :callback_plano="filtrar_search" />
                            </div>

                            <div class="col col-12 col-md-8" v-else-if="hor.bloqueio">
                            {{ hor.bloqueio.st_observacao }}
                            </div>

                            <!-- Identificação do Procedimento -->
                            <div class="col col-12 col-md-4 d-flex justify-content-between" v-if="hor.marcacao">
                            <celula-dados-procedimento :hor="hor" @abriranexos="abrir_anexar_arquivo" @abrirpreatend="$refs.doc_pre_atend.abrir" />
                            <!-- Menu de opções -->
                            <div class="dropleft d-flex align-items-center justify-content-center order-1 order-md-2">
                                <a href="#" role="button" data-toggle="dropdown">
                                <i class="fas fa-ellipsis-v"></i>
                                </a>
                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <button class="dropdown-item" @click="filtrar_procedimento(hor.marcacao)" v-if="!filtrados.find(item => item.id == hor.marcacao.id_procedimento)">
                                    Não exibir este procedimento
                                </button>
                                <button class="dropdown-item" @click="remover_filtra_procedimento(hor.marcacao)" v-else>
                                    Re-exibir este procedimento
                                </button>
                                <template v-if="filtrados && filtrados.length">
                                    <button class="dropdown-item" @click="limpar_filtro_procedimentos()">
                                    Limpar filtro de procedimentos
                                    </button>
                                    <button class="dropdown-item" @click="exibir_filtrados()">
                                    Listar {{ filtrados.length == 1 ? 'procedimento filtrado' : 'procedimentos filtrados' }}
                                    ({{ filtrados.length }})
                                    </button>
                                </template>
                                </div>
                            </div>
                            </div>

                        </div>

                    </div>

                    <div class="p-0" v-if="hor.marcacao && hor.marcacao.paciente && hor.marcacao.paciente.atendimento_pacotes && hor.marcacao.paciente.atendimento_pacotes.length">
                        <historico-pacotes-paciente 
                            autoriz2="true"
                            :id_atendimento="hor.marcacao.id_atendimento"
                            :id_procedimento="hor.marcacao.id_procedimento"
                            :lista="hor.marcacao.paciente.atendimento_pacotes" 
                            :ativos="true"
                            :reduzido="true" />
                    </div>
                    
                </div>
                </template>

                </div>

                <div v-if="show_empty_state">
                <az-empty-state 
                    :feriado="feriado"
                    :bloqueio="bloqueio"
                    :msg="lista === null 
                    ? 'Clique aqui para buscar.'
                    : ( search
                            ? 'Nenhum paciente encontrado.'
                            : 'Nenhum paciente marcado para essa data.' 
                    )
                    "
                    :icon="lista === null ? 'fas fa-sync-alt' : ( search ? 'fas fa-search' : 'fas fa-user-clock' )" 
                    :action="lista === null ? 'Buscar' : ''"
                    :method="load">
                </az-empty-state>
                </div>

                <template v-if="1 == 1 || $store.state.user.id_usuario == 1">
                <hr>

                <div class="text-center">
                    <a href="#" class="card-link" @click.prevent="tour()">
                    <i class="far fa-compass fa-2x"></i>
                    </a>
                </div>
                </template>

            </div>

            <!-- Modal Paciente Primeira Vez -->
            <div class="modal fade" id="novoPacienteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" v-if="marcacao && marcacao.cadastro_temporario">
                    <h5 class="modal-title" id="exampleModalLabel">{{ marcacao.cadastro_temporario.st_nome }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-header" v-if="marcacao && marcacao.paciente">
                    <h5 class="modal-title" id="exampleModalLabel">
                        Paciente Agendado
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <template v-if="marcacao && marcacao.paciente">
                        <div class="card">
                        <div class="card-body">
                            <celula-dados-paciente :hor="{ marcacao: marcacao }" />
                            <hr>
                            <celula-dados-procedimento :hor="{ marcacao: marcacao }" :blockanexos="true" />
                        </div>
                        </div>

                        <template v-if="marcacao.paciente.atendimento_pacotes">
                        <pacotes-do-paciente :pacotes="marcacao.paciente.atendimento_pacotes" />
                        </template>

                        <pre class="alert alert-warning" v-if="false">{{ marcacao.paciente }}</pre>
                    </template>
                    <az-empty-state msg="Paciente Primeira Vez." icon="far fa-user" v-else></az-empty-state>
                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-outline-danger" @click="cancelarAtendimento(marcacao)" v-if="pode_atender">
                        Cancelar Marcação
                    </button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    <az-submit @click="iniciarAtendimento (marcacao)" v-if="pode_atender">Atendimento</az-submit>
                    </div>
                </div>
                </div>
            </div>

            <!-- Modal Marcação -->
            <div class="modal fade" id="novoAtendimentoConsultorioModal" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-dialog2" role="document">
                <div class="modal-content modal-content2">
                    <div class="modal-header">
                    <span>Agendar Atendimento</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <marcacao
                        ref="marcacao"
                        origem="consultorio"
                        :data="referencia"
                        :hora="refHora"
                        :hg="refHg"
                        :id_unidade_operacao="refUnidOper"
                        modalName="novoAtendimentoConsultorioModal"
                        @refresh="load(false)"
                        />
                    </div>
                </div>
                </div>
            </div>

            <!-- Envio de Arquivo -->
            <template v-if="acao_anexar">
                <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="marcacao.arquivos"
                :parms="{ model_type: 'marcacao', model_id: marcacao.id_marcacao }" />
            </template>

            <!-- Cancelar Marcação -->
            <cancelar-marcacao ref="canc_atd_consultorio" @cancelado="load(false)" />

            <!-- Iniciar Atendimento -->
            <iniciar-atendimento ref="ini_atd_consultorio" @refresh="load(false)" />

            <!-- Pré Atendimento -->
            <documento-pre-atendimento ref="doc_pre_atend" />

            <!-- Documentos -->
            <documento ref="documento" :recepcao="true" refresh="imprimir_documento" />

            <!-- Procedimentos Filtrados -->
            <div class="modal fade" id="consultorioFiltradosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
                <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="filtrados">
                    <div class="modal-header">
                    <h5 class="modal-title">Procedimentos Filtrados</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    </div>
                    <div class="modal-body">
                    <p class="alert alert-info" v-if="!filtrados.length">Nenhum procedimento selecionado.</p>

                    <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between" v-for="(flt, ifx) in filtrados" :key="ifx">
                        <div>{{ flt.search }}</div>
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="remover_filtra_procedimento({ id_procedimento: flt.id })">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                        </li>
                    </ul>
                    </div>
                    <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
                </div>
            </div>

            <video id="beepElementId" src="https://api.klingo.app/message-chamar.mp3" style="display: none;" ></video>

            <br><br><br><br><br><br>

        </template>


        <!-- Visualização da Fila do Consultório -->
        <template v-else>

            <div class="form-row mb-3">
                <div class="col col-12 d-flex flex-column">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="tipo_ordem == 'P' ? 'btn-secondary' : 'btn-outline-secondary'" @click.prevent="set_tipo_ordem('P')">Ordem Padrão</button>
                        <button type="button" class="btn" :class="tipo_ordem == 'M' ? 'btn-secondary' : 'btn-outline-secondary'" @click.prevent="set_tipo_ordem('M')">Ordem Marcação</button>
                        <button type="button" class="btn" :class="tipo_ordem == 'C' ? 'btn-secondary' : 'btn-outline-secondary'" @click.prevent="set_tipo_ordem('C')">Ordem Check-In</button>
                        <button type="button" class="btn" :class="tipo_ordem == 'A' ? 'btn-secondary' : 'btn-outline-secondary'" @click.prevent="set_tipo_ordem('A')">Ordem Atendimento</button>
                        <button type="button" class="btn" :class="tipo_ordem == 'G' ? 'btn-secondary' : 'btn-outline-secondary'" @click.prevent="set_tipo_ordem('G')" v-if="tem_ordem_pag">Ordem Pagamento</button>
                    </div>        
                </div>
            </div>

            <div v-for="(quebra, iq) in exibicao" :key="iq">

                <div class="mt-3 mb-1 d-flex" v-if="iq != ' Lista '"> 
                    <h5 class="mb-0">
                        <a href="#" @click.prevent="toggle_retracao(iq)">
                            <i class="far fa-minus-square mr-2" v-if="!retracao[iq]"></i>
                            <i class="far fa-plus-square mr-2" v-else></i>
                        </a>
                        {{ iq }}
                        <span class="badge badge-secondary">{{ quebra.length }}</span>
                    </h5>
                </div>

                <div v-else-if="false">
                    <span class="badge badge-secondary">{{ quebra.length }}</span>
                </div>

                <template v-if="!retracao[iq]">
                    <table class="table table-sm table-hover bg-white">
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Agenda</th>
                                <th>CheckIn</th>
                                <th>Atend.</th>
                                <th>Número</th>
                                <th>Paciente</th>
                                <th>Procedimento</th>
                                <th>Profissional</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(hor, index) in quebra" :key="iq + '-' + index">
                                <td>
                                    <span class="badge" :class="'badge-' + checkStatus(hor).color">
                                        {{ checkStatus(hor).title }}
                                    </span>
                                </td>
                                <td>
                                    {{ hor.marcacao.dt_inicio.slice(11,16) }}
                                </td>
                                <td>
                                    <span v-if="hor.marcacao.dt_checkin">{{ hor.marcacao.dt_checkin.slice(11,16) }}</span>
                                </td>
                                <td>
                                    <span v-if="hor.marcacao.atendimento">{{ hor.marcacao.atendimento.dt_inicio.slice(11,16) }}</span>
                                </td>
                                <td>
                                    <span v-if="hor.marcacao.id_atendimento">
                                        #{{ hor.marcacao.id_atendimento }}
                                    </span>

                                    <i :class="hor.marcacao.sinalizador_atendimento.st_icon + ( hor.marcacao.sinalizador_atendimento.st_cor ? ' text-' + hor.marcacao.sinalizador_atendimento.st_cor : '' )" class="fa-fw mr-2" v-if="hor.marcacao.sinalizador_atendimento"></i>
                                </td>
                                <td>
                                    {{ hor.marcacao.nome_paciente }}
                                    <span v-if="hor.marcacao.paciente && hor.marcacao.paciente.sinalizadores" class="ml-1">
                                        <span v-for="(sinal, isx) in hor.marcacao.paciente.sinalizadores" :key="isx" :title="sinal.sinalizador.search">
                                            <i class="fa-fw" :class="( sinal.sinalizador.st_icon ? sinal.sinalizador.st_icon : 'fas fa-flag') + ' text-'  + sinal.sinalizador.st_cor" aria-hidden="true"></i>
                                        </span>
                                    </span>
                                </td>
                                <td>
                                    {{ hor.marcacao.procedimento.search }}
                                </td>
                                <td>
                                    {{ hor.marcacao.medico.search }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>

            </div>

        </template>
      
    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import Marcacao from '../callcenter/Marcacao.vue';
import CancelarMarcacao from "../callcenter/CancelarMarcacao.vue";
import IniciarAtendimento from "../recepcao/IniciarAtendimento.vue";
import DocumentoPreAtendimento from '../../shared/DocumentoPreAtendimento.vue';
import Documento from './Documento.vue';

import CelulaHorariosMarcacao from '../../shared/table/CelulaHorariosMarcacao.vue';
import CelulaDadosPaciente from '../../shared/table/CelulaDadosPaciente.vue';
import CelulaDadosProcedimento from '../../shared/table/CelulaDadosProcedimento.vue';

import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';

import AzFileUpload from '../../util/AzFileUpload.vue';
import RelatoriosLinkados from '../../relatorios/shared/RelatoriosLinkados.vue';

import { subscribe } from "../../../service/Notify";
import EventBus from '../../../service/EventBus';

import PacotesDoPaciente from '../../shared/PacotesDoPaciente.vue';
import HistoricoPacotesPaciente from '../../shared/HistoricoPacotesPaciente.vue';

export default {
    data () { 
        return {
          marcacoes: [],
          atendimentos: [],
          paciente: {}, 
          search: "",
          showPanel: false,
          marcacao: null,
          lista: [],
          search_timeout: null, 
          viewMode: 'A',
          refHora: "",
          refHg: "", 
          feriado: null, 
          bloqueio: null, 
          local: "", 
          pode_atender: false, 
          referencia: this.$util.hoje(),
          acao_anexar: false, 
          refUnidOper: null, 
          classe: "T",
          montando: true, 
          medico_adm: "", 
          retracao: [], 
          config_atende_pre: false,
          filtrados: [], 
          outros: null, 
          is_emergencia: false, 
          tmaInterval: null, 
          agora: null, 
          tarefas: [],
          refresher: null, 
          faixa_hora: "", 
          config_apuracao_repasse: false, 
          te_max: null,
          atender_expresso: false, 
          local_item: "", 
          tipo_ordem: "P", 
          viewModeClasse: "A", 
          integracao_ymunity: null,
        }
    },

    props: ['ver_fila', 'id_medico_ver_fila', 'fila_ref'], 

    components: { 
      AzEmptyState,
      Marcacao,
      CelulaHorariosMarcacao,
      CelulaDadosPaciente,
      CelulaDadosProcedimento,
      CancelarMarcacao, 
      IniciarAtendimento,
      AzSubmit, 
      PrintExport,
      CabecalhoGenerico, 
      AzFileUpload, 
      RelatoriosLinkados, 
      AzInput,
      DocumentoPreAtendimento,
      Documento, 
      PacotesDoPaciente, 
      HistoricoPacotesPaciente, 
    },
    computed: {
      tem_ordem_pag: function () { 
        return window.redir == 'teste' || window.redir == 'clin28dejulho';
      },

      pode_acao: function () { 
        if ( this.$store.state.user.id_usuario != 1 && this.$store.state.user.medico && this.$store.state.user.ver_md && this.medico_adm && this.medico_adm != this.$store.state.user.id_pessoa ) { 
          return false;
        }

        return true; 
      }, 

      lista_opcoes_relatorio: function () { 
        let lista = [
          { title: 'Listagem', callback: this.imprimirLista },
          { title: 'Emitir Documento', callback: this.novoDocumento }
        ];

        if ( this.config_apuracao_repasse ) { 
          lista.push(
            { title: 'Apuração da Produção', callback: this.ver_repasse }
          );
        }

        if ( this.$store.state.user.zd ) { 
          lista.push(
            { title: 'Zerodox', callback: this.abrir_zerodox }
          );
        }
        if ( this.integracao_ymunity ) {
          lista.push(
            { title: 'Ymunity', callback: this.abrir_ymunity }
          );
        }

        return lista;
      },

      show_empty_state: function () { 
        return !this.exibicao && !this.exibicao_outros && ( !this.tarefas || !this.tarefas.length );
      },

      referencia2: {
        get () {
          return this.$store.state.referencia
        },
        set (value) {
          this.$store.commit('setReferencia', value)
        }
      },

      lista_tarefas: function () { 
        return _.slice(this.tarefas, 0, 2);
      },

      exibicao_outros: function () { 
        if ( !this.outros ) 
          return;

        if ( !this.outros.length ) 
          return;

        return this.outros;
      },

      campo_ordem: function () { 
        switch (this.tipo_ordem) {
            case 'M':
                return 'marcacao.dt_inicio';

            case 'C':
                return 'marcacao.dt_checkin';
        
            case 'A':
                return 'marcacao.atendimento.dt_inicio';

            case 'G':
                return 'marcacao.dt_pag';
        }

        return '';
      },

      exibicao: function () { 
        let self = this;
        let items = this.lista ? this.lista : []; 

        if ( this.viewMode == 'G' ) { 
            items = _.orderBy(items, 'hora');
        }

        if ( this.viewMode == 'A' || this.viewMode == 'E' ) {
          items = items.filter(item => { return item.marcacao ? true : false; });
        }

        if ( this.faixa_hora ) { 
          items = items.filter(item => ( item.hora < '13:00' && this.faixa_hora == 'M' )
            || ( item.hora >= '13:00' && item.hora < '18:00' && this.faixa_hora == 'T' )
            || ( item.hora >= '13:00' && this.faixa_hora == 'TN' )
            || ( item.hora >= '18:00' && this.faixa_hora == 'N' ) )
        }

        if ( this.classe == 'F' ) { 
            if ( this.viewModeClasse == 'E' ) { 
                items = items.filter(item => item.marcacao && this.filtrados.find(flt => flt.id == item.marcacao.id_procedimento));
            } else { 
                items = items.filter(item => item.marcacao && !this.filtrados.find(flt => flt.id == item.marcacao.id_procedimento));
            }
        } else if ( this.classe != 'T' && this.classes.length > 1 ) { 
            if ( this.viewModeClasse == 'E' ) { 
                items = items.filter(item => item.marcacao && item.marcacao.procedimento.id_classe_procedimento != this.classe);      
            } else { 
                items = items.filter(item => item.marcacao && item.marcacao.procedimento.id_classe_procedimento == this.classe);
            }
        }

        if ( !items.length )
          return null;

        console.log('items', this.tipo_ordem, items);

        if ( this.campo_ordem ) { 
            items = _.orderBy(items, this.campo_ordem); 
        }

        if ( this.tipo_ordem && ( this.tipo_ordem != 'P' ) ) { 
            items = _.orderBy(items, 'ords');
        }
         
        items = _.groupBy(items, item => { 
          if ( self.viewMode == 'A' || self.viewMode == 'E' ) { 
            if ( _.get(item, 'marcacao.item_status.nocons') ) { 
              return 'Procedimento';
            }

            if ( !item.marcacao.atendimento && !item.marcacao.dt_chamada_recepcao ) { 
              return item.marcacao.dt_inicio.slice(0,10) < this.$util.hoje() ? 'Faltosos' : 'Agendados';
            }

            return this.checkStatus(item).title == 'Atendido'  
                ? 'Atendidos'
                : ( this.checkStatus(item).title == 'Pausado' ? ' Pausados ' : ' Lista ' ); 
          } else { 
            return ' Lista ';
          }
        });

        if ( self.viewMode == 'A' || self.viewMode == 'E' ) { 

          let ordered = {};   
          _(items).keys().sort().each(function (key) {
            ordered[key] = items[key];
          });

          return ordered;

        }

        return items;
      },

      classes: function() { 
        if ( !this.lista )
          return [];

        return _.uniqBy(
            this.lista.filter(item => item.marcacao && item.marcacao.procedimento && item.marcacao.procedimento.classe_procedimento)
              .map(item => _.get(item, 'marcacao.procedimento.classe_procedimento')),
            item => ( item ? item.id_classe_procedimento : {} )
          );
      },

      lista_classes: function () { 
        let lista = [
          { id: 'T', search: 'TODOS' }
        ];

        if ( this.filtrados && this.filtrados.length ) { 
          lista.push({ id: 'F', search: 'FILTRADOS' })
        }

        lista = lista.concat(
          _.sortBy(
            this.classes.map(item => { 
              return { id: item.id_classe_procedimento, search: item.search }         
            }),
            item => item.search
          )
        );
        
        return lista;
        
      },

      lista_status: function () { 
        return _.map(
          _.groupBy(
            _.flatMap(this.exibicao, items => items)
              .filter(item => item.status == 'ocupado')
              .map(item => { 
                return this.checkStatus(item);
              }
            ),
            'title'
          ),
          items => { 
            return { 
              ...items[0],
              count: items.length
            }
          }
        );
      },

      lista_locais: function() { 
        console.log(this.local, this.local.indexOf('|') );
        if ( this.local && this.local.indexOf('|') > 0 ) { 
          return this.local.split('|')
            .map(loc => { 
              return { 
                id: loc.trim(),
                search: loc.trim() 
              };
            });
        }

        return [];
      }

    },

    watch: { 
      viewModeClasse: function(newValue) { 
        if ( !this.montando )
          this.$util.setCookie('cns-cl-escopo', newValue, 365);
      },
      classe: function(newValue) { 
        if ( !this.montando )
          this.$util.setCookie('consultorio-classe', newValue, 365);
      },

      filtrados: function(newValue) { 
        if ( !this.montando )
          this.$util.setCookie('consultorio-proc-filtro', JSON.stringify(newValue), 365);
      },

      faixa_hora: function(newValue) { 
        this.$store.commit('setContexto', { consultorio_faixa_hora: newValue });
      },

      viewMode: function (newValue) { 
        this.$util.setCookie('cn-vm', newValue, 365);
      }
    },

    methods: { 
        info_campo_ordem (hor) { 
            let info = this.campo_ordem ? _.get(hor, this.campo_ordem) : "";

            if ( !info ) { 
                return '?'; 
            }

            if ( info === '9999-99-99' ) { 
                return info; 
            }

            return info ? this.$util.getFormatDate(info) + ' ' + info.slice(11,16) : ''; 
        },

        tem_pre_atendimento (marcacao) { 
            if ( !marcacao ) 
                return false;   

            return ( ( marcacao.procedimento && marcacao.procedimento.fl_pre_atendimento ) || ( marcacao.atendimento && marcacao.atendimento.atend_proc_pre_atends_count > 0 ) )
                ? true 
                : false; 
        }, 
        
        abrir_ymunity () { 
            const unidadeOpe = this.$util.unidade_operacao();

            this.$util.loadItem(this, { 
                service: 'medicos',
                func: 'ymunity_get_url',
                parms: { id_unidade_operacao: unidadeOpe ? unidadeOpe.id_unidade_operacao : null },
            })
            .then(res => { 
                if ( res && res.url ) { 
                    window.open(res.url, '_blank');
                }
            });
        },

        abrir_zerodox () { 
            this.$util.loadItem(this, { 
                service: 'zerodox',
                func: 'get_url',
            })
            .then(res => { 
                if ( res && res.url ) { 
                    window.open(res.url, '_blank');
                }
            });
        },

        set_tipo_ordem (tipo) { 
            this.tipo_ordem = tipo; 
            this.$util.setCookie('CS-ORD', tipo, 365);
        },

      filtrar_search (search) { 
        if ( this.search == '"' + search + '"' )
          this.search = "";
        else
          this.search = '"' + search + '"';

        this.pesquisar();
      },

      ver_repasse () { 
        this.$router.push({ name: 'consultorio-apuracao' });
      },

      beep() {
        const el = document.getElementById("beepElementId");
        el.play();
      },

      novoDocumento() { 
        this.$refs.documento.novoDocumento();
      },

      duracao (data, humanize = true) { 
        return humanize
          ? moment
            .duration(moment(data, "YYYY-MM-DD HH:mm:ss").diff(this.agora))
            .humanize(true)
          : moment
            .duration(moment(this.agora, "YYYY-MM-DD HH:mm:ss").diff(data))
            .asMinutes();
      },

      incluir_avulso(hor) {

        if ( !hor.marcacao || !hor.marcacao.id_atendimento ) { 
          return;
        }

        this.$util.atualizar(this, { 
          service: 'pep',
          func: 'incluir_avulso',
          dados: { 
            id_paciente: hor.marcacao.id_paciente,
            id_procedimento: hor.marcacao.id_procedimento,  
            id_atendimento_origem: hor.marcacao.id_atendimento, 
          },
          callback: res => { 
            $(".modal").modal("hide");
            this.$router.push({ path: "/consultorio/res/" + res.id_atendimento });
          }
        });

      },

      trocar_visao(tipo) { 
        this.lista = [];
        this.viewMode = tipo;
        this.load();
      },

      acao_dos_outros (hor) { 
        this.$toast.add({
          severity: "warn",
          summary: "Atenção",
          detail: "Paciente de outro profisisonal. " + _.get(hor, 'marcacao.nome_paciente'),
          life: 5000
        });

        return;
      },

      para_mim (hor) { 
        if ( hor && hor.medico && ( 
          hor.medico.fl_agenda_compartilhada 
          || hor.medico.id_pessoa == this.medico_adm 
          || hor.medico.id_pessoa == this.$store.state.user.id_pessoa ) ) { 

          return true;

        }

        return false;
      },

      executar_acao_outro(outro, acao) { 
        outro.loading = true;

        let dados = _.cloneDeep(outro);

        dados.id_etapa_atendimento = acao.id_proxima_etapa;
        dados.consultorio = true;
        dados.local = this.$util.getCookie('local-chamada');

        this.$util.atualizar(this, { 
          service: 'atendimento_outros',
          dados: dados, 
          callback: () => { 
            this.load();
          }
        });
      },

      refresh_local() { 
        this.local = this.$util.getCookie('local-chamada');
        
        if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) {
          this.load();
        }
      },

      exibir_filtrados () {
        $('#consultorioFiltradosModal').modal('show');
      },

      filtrar_procedimento (marcacao) { 
        this.filtrados.push({
          id: marcacao.id_procedimento,
          search: marcacao.procedimento.search, 
        });

        this.classe = 'F';
      },

      remover_filtra_procedimento (marcacao) { 
        let index = this.filtrados.findIndex(item => item.id == marcacao.id_procedimento);

        if ( index >= 0 ) { 
          this.filtrados.splice(index, 1);
        }

        if ( !this.filtrados.length ) { 
          this.classe = 'T';
        }
      },

      limpar_filtro_procedimentos () { 
        this.classe = 'T';

        this.filtrados = [];
      },

      toggle_retracao(iq) { 
        this.retracao[iq] = this.retracao[iq] ? false : true;
        this.$util.setCookie('CS-' + iq, this.retracao[iq] ? 1 : 0, 365);
        this.$forceUpdate();
      },

      anotacoes (marcacao) { 

        if ( marcacao.id_atendimento ) {
          
          this.$util.atualizar(this, { 
            service: 'atendimentos', 
            func: 'iniciar',
            dados: { 
              id: marcacao.id_atendimento,
              blockprogresso: true, 
            },
            callback: () => { 
              this.$router.push({name: 'res', params: { id: marcacao.id_atendimento, anotacoes: true }});
            }
          });

        } else { 

          this.$util.atualizar(this, { 
            service: 'atendimentos', 
            func: 'preiniciar',
            dados: { 
              id_marcacao: marcacao.id_marcacao,
            },
            callback: res => { 
              this.$router.push({name: 'res', params: { id: res.id_atendimento, anotacoes: true }});
            }
          });

        }

      },

      ativar_rebuscar() { 
        this.lista = null;

        if ( this.referencia == this.$util.hoje() ) { 
          this.load();
        }
      },

      imprimirLista() { 
        this.$htmlToPaper('lista-pacientes', null);
      },

      abrir_anexar_arquivo(marcacao) { 
        this.marcacao = marcacao;
        this.acao_anexar = true;

        if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) { 

          this.carregar_arquivos(true);

          return;

        }

        this.$nextTick(() => { 
          this.$refs.upload.abrir();
        });
      },

      carregar_arquivos (abrir = false) { 

        this.$store.commit('loading', true);

        this.$util.loadItem(this, { 
          service: 'arquivos',
          func: 'links',
          parms: { 
            id: this.marcacao.id_marcacao, 
            type: 'marcacao',
          }
        })
        .then(res => { 
          this.marcacao.arquivos = res;

          if ( abrir ) { 
            this.$nextTick(() => { 
              this.$refs.upload.abrir();
            });
          }
        })
        .finally(() => { 
          this.$store.commit('loading', false);
        });

      },

      telemed_integra () { 
        this.$util.atualizar(this, { 
          service: 'integrador',
          func: 'obter_atendimentos',
          dados: { 
            data: this.referencia.substr(0,10),
          },
          toast: true, 
          callback: () => { 
            this.load();
          }
        });
      },

      iniciarAtendimento (item) { 
        if ( item.direto ) { 

          let id_uo = this.$util.getCookie('id_unidade_operacao');
          let id_rc = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

          let recep = this.$util.recepcao();

          if ( recep ) { 
            id_uo = recep.id_unidade_operacao;
            id_rc = recep.id_recepcao;
          }

          this.$util.atualizar(this, { 
            service: 'marcacoes',
            func: 'cerimonial_checkin',
            dados: { 
              id_marcacao: item.id_marcacao, 
              id_unidade_operacao: id_uo,
              id_recepcao: id_rc,
              expresso: true, 
              origem: 'consultorio',
            },
            modal: 'novoPacienteModal',
            toast: true, 
            callback: res => { 
              console.log ('item', item);
              console.log ('retorno', res);

              if ( res && res.atendimento ) { 
                // item.id_atendimento = res.atendimento.id_atendimento;
                // item.atendimento = res.atendimento;
              }

              if ( res && res.expresso && res.atendimento ) { 
                this.chamar({ marcacao: item }, res.atendimento);
              }
            }
          });

          return;
        }

        this.$store.commit("loading", true);

        let query = {
          q: [
            {
              name: "marcacoes.show",
              id: "item",
              parms: {
                id: item.id_marcacao,
                para_atendimento: true
              }
            }
          ]
        };

        this.axios
          .post("/aql", query)
          .then(res => {
            if (res.data.item.status == 200) {
              let marcacao = res.data.item.data;
              $('.modal').modal("hide");
              $('[data-toggle="tooltip"]').tooltip("dispose");
              this.$refs.ini_atd_consultorio.abrir(marcacao, 1);
            }
          })
          .finally(() => {
            this.$store.commit("loading", false);
          });

      },

      cancelarAtendimento(marcacao) {
        $('.modal').modal('hide');
        this.$refs.canc_atd_consultorio.cancelar(marcacao);
      },
      checkStatus (hor) { 
        if ( hor.status == 'livre' ) { 
          return { 
            status: 'livre',
            color: 'secondary', 
            title: 'Horário Livre',
            icon: 'far fa-calendar-alt',
            action: this.verMarcar,
           } ;
        } else if ( hor.status == 'bloqueado' ) { 
          return { 
            status: 'bloqueado',
            color: 'danger', 
            title: 'BLOQUEADO',
            icon: 'fas fa-ban',
            action: null,
           } ;
        } else if ( hor.status == 'ocupado' && !hor.marcacao ) { 
          return { 
            status: 'grupo',
            color: 'info', 
            action: null,
            title: 'Grupo',
            icon: 'fas fa-user-clock',
           } ;
        } else if ( hor.status == 'ocupado' && hor.marcacao && hor.marcacao.ch_estado_marcacao == 'C' ) { 
          return { 
            status: 'cancelado',
            color: 'secondary', 
            title: 'Cancelado',
            icon: 'fas fa-ban',
            action: hor.marcacao.paciente ? this.verPep : this.verPrimeiraVez
           } ;
        } else if ( hor.status == 'ocupado' && hor.marcacao && !hor.marcacao.atendimento && hor.marcacao.dt_chamada_recepcao ) { 
          return { 
            status: 'agendado',
            color: 'warning', 
            title: 'Chamado Recepção',
            icon: 'fa-solid fa-bell-concierge',
            action: hor.marcacao.paciente ? this.verPep : this.verPrimeiraVez
           } ;
        } else if ( hor.status == 'ocupado' && hor.marcacao && !hor.marcacao.atendimento && hor.marcacao.dt_checkin ) { 
          return { 
            status: 'agendado',
            color: 'warning', 
            title: 'Check-In',
            icon: 'fas fa-user-check',
            action: hor.marcacao.paciente ? this.verPep : this.verPrimeiraVez
           } ;
        } else if ( hor.status == 'ocupado' && hor.marcacao && !hor.marcacao.atendimento ) { 
          return { 
            status: 'agendado',
            color: 'info', 
            title: ( hor.marcacao.dt_inicio.slice(0,10) < this.$util.hoje() ? 'Faltoso' : 'Agendado' ) + ( ( hor.marcacao.orcamento && hor.marcacao.orcamento.id_pagamento_atendimento ) ? ' (Pg)' : '' ),
            icon: 'fas fa-user-clock',
            action: ( hor.marcacao.paciente && ( !this.pode_atender || hor.marcacao.procedimento.id_classe_procedimento != 17 ) )
              ? this.verPep : this.verPrimeiraVez
           } ;
        // PRÉ-ATENDIMENTO
        } else if ( hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.ultima_etapa && hor.marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'P' ) { 
          if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 11 ) { 
            return { 
              status: 'chamado-pre',
              color: 'secondary', 
              title: 'Chamado Pré-Atendimento',
              icon: '',
              action: this.verPep
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 12 ) { 
            return { 
              status: 'atendendo-pre',
              color: 'secondary', 
              title: 'Em Pré-Atendimento...',
              icon: 'success',
              action: this.verPep
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 13 ) { 
            return { 
              status: 'atendido-pre',
              color: 'success', 
              title: 'Chamar Paciente',
              icon: 'fas fa-check',
              action: this.chamar,
              fill: true, 
            } ;
          }
        // ATENDIMENTO NORMAL
        } else if ( hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.ultima_etapa && hor.marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'C' ) { 
          if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 5 ) { 
            return { 
              status: 'chamado',
              color: 'danger', 
              title: 'Chamado',
              icon: 'fas fa-volume-up',
              action: this.verPep
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6 ) { 
            return { 
              status: 'atendendo',
              color: 'success', 
              title: 'Em Atendimento...',
              icon: 'success',
              action: this.verRes,
              complemento: true,
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 7 ) { 
            return { 
              status: 'atendido',
              color: 'primary', 
              title: 'Atendido',
              icon: 'fas fa-check',
              action: this.verRes,
              complemento: true,
              backcolor: 'primary', 
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 9 ) { 
            return { 
              status: 'pausado',
              color: 'secondary', 
              title: 'Pausado',
              icon: 'fa fa-pause',
              action: this.verRes,
              complemento: true, 
              backcolor: 'secondary', 
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 10 ) { 
            return { 
              status: 'nao-compareceu',
              color: 'secondary', 
              title: 'Não Compareceu',
              icon: 'fas fa-times',
              action: this.verPep
            } ;
          }
        // POS-ATENDIMENTO
        } else if ( hor.marcacao && hor.marcacao.item_status && hor.marcacao.item_status.ultima_etapa && hor.marcacao.item_status.ultima_etapa.ch_tipo_atendimento == 'D' ) { 
          if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 14 ) { 
            return { 
              status: 'chamado-pos',
              color: 'secondary', 
              title: 'Chamado Procedimento',
              icon: '',
              action: this.verPep
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 15 ) { 
            return { 
              status: 'atendendo-pos',
              color: 'secondary', 
              title: 'Em Procedimento...',
              action: this.verRes
            } ;
          } else if ( hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 16 ) { 
            return { 
              status: 'atendido-pos',
              color: 'primary', 
              title: 'Chamar Novamente',
              icon: 'fas fa-check',
              fill: true, 
              action: this.chamar,
              complemento: true 
            };
          }
        } else { 
          if ( hor.marcacao.outras && hor.marcacao.outras.find(item => item.id_marcacao != hor.marcacao.id_marcacao && item.item_status.valor == 'em atendimento') ) { 
            return { 
                    status: 'chamar',
                    color: 'dark', 
                    title: 'Em Outro Atendimento...',
                    icon: 'fas fa-ban',
                    fill: false,
                    action: this.verPep
                  } ;    
          } else if ( !hor.marcacao.item_status.na_recepcao && hor.marcacao.item_status && hor.marcacao.item_status.ultima_etapa && hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento > 1 ) { 
            if ( hor.marcacao.item_status.block_proc ) { 
              return {  
                status: 'chamar',
                color: 'secondary', 
                title: 'Aguardando ' + hor.marcacao.item_status.block_proc + '...',
                icon: '',
                fill: false,
                action: this.verPep 
              };    
            } else { 
              return {  
                  status: 'chamar',
                  color: this.tem_pre_atendimento(hor.marcacao) ? 'secondary' : 'success', 
                  title: 'Chamar Paciente',
                  icon: 'fas fa-bell',
                  fill: this.tem_pre_atendimento(hor.marcacao) ? false : true,
                  action: this.chamar 
                };    
            }
          }

          return { 
                  status: 'recepção',
                  color: 'warning', 
                  title: 'Na Recepção',
                  icon: 'fas fa-user-friends',
                  fill: false,
                  action: this.mensagem 
                } ;    
        }
      },
      
      pesquisar () { 

        this.$store.commit('loading', true);
      
        if ( this.search_timeout )
          clearTimeout(this.search_timeout);

        this.search_timeout = setTimeout(() => {
          this.filtrar ();
          this.search_timeout = null;
        }, 300);

      },
      filtrar () { 

        let pesquisar = this.search.trim();
        let parts = pesquisar.replace(' ','.*');
        let match = parts;
        let reg = new RegExp(match, 'i');
        let items;

        if ( pesquisar ) {
            items = this.marcacoes.filter(item => { 
                return reg.test(JSON.stringify(item));
            });
        } else { 
            items = this.marcacoes;
        }

        this.lista = _.cloneDeep(items);

        this.$store.commit('loading', false);

      },
      iniciar (atd) { 
        let marcacao = _.cloneDeep(atd.marcacao);
        this.$refs.ini_atd.abrir(marcacao);
      },
      getHora (valor) { 
        if ( valor )
          return valor.substr(11, 5);
      },
      show_cadastro (paciente) { 
        this.paciente = paciente;
      },
      mensagem (hor) { 
        let status = this.checkStatus (hor);

        if ( status.status == 'recepção' ) { 
          alert('Paciente em atendimento na recepção.');
        }
      },
      chamar (hor, atendimento = null) { 

        let verificar_permissao_sem_pre_atend = false; 

        if ( this.lista_locais.length && !this.local_item ) { 
          this.$toast.add({ 
            severity: "warn",
            summary: "Atenção",
            detail: "Selecione o local da chamada: \n" + this.lista_locais.map(loc => loc.search).join("\n"),
            life: 5000      
          });

          return; 
        }

        if ( !atendimento ) { 
          // Verificação de pré-atendimento...
          let status = this.checkStatus (hor);
          
          if ( status.status == 'chamar' && this.tem_pre_atendimento(hor.marcacao) ) { 
            if ( !confirm('Pré-atendimento ainda não realizado para esse paciente. Confirma chamar mesmo assim?') ) 
              return;

            verificar_permissao_sem_pre_atend = true;
          }
          //
        }

        this.$store.commit('loading', true);

        hor.loading = true;

        let query = { q: [
          { 
            name: "atendimentos.chamar",
            id: "chamada",
            parms: { 
              id: atendimento ? atendimento.id_atendimento : hor.marcacao.atendimento.id_atendimento, 
              id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null,
              local: this.local_item ? this.local_item : this.$util.getCookie('local-chamada'),
              block_painel: this.$util.getCookie('nao-enviar-painel'), 
              perm_pre_atend: verificar_permissao_sem_pre_atend, 
              iniciar_ao_chamar: this.$util.getCookie('cn-iac') == 'S' ? true : false, 
            }
          }
        ]};

        this.axios.post('/aql?a=atendimentos.chamar', query)
          .then(res => { 
            if ( !res.data )
              return;

            if ( res.data.chamada.status == 200 ) { 

              if ( process.env.VUE_APP_GTAG ) { 

                let action = 'chamar-consultorio';
                let label = this.$store.state.user.st_login;

                this.$gtag.event(action, {
                    'event_category': window.redir,
                    'event_label': label,
                    'value': 1
                });

              }

              hor.marcacao.item_status.ultima_etapa = res.data.chamada.data.etapa_atendimento;
              this.$store.commit('loading', false);

              if ( hor.marcacao.item_status.ultima_etapa
                && hor.marcacao.item_status.ultima_etapa.id_etapa_atendimento == 6) { 

                this.verRes (hor);

              } else { 

                this.verPep (hor);

              }

            }
          })
          .finally (() => { 
            this.$store.commit('loading', false);
            hor.loading = false;
          });
      },
      verPep (hor) {
        $('[data-toggle="tooltip"]').tooltip('hide');
        this.$router.push({path: '/consultorio/' + hor.marcacao.id_paciente + '/' + hor.marcacao.id_atendimento});
      },
      verRes (hor) { 
        $('[data-toggle="tooltip"]').tooltip('hide');
        this.$router.push({path: '/consultorio/res/' + hor.marcacao.atendimento.id_atendimento});
      },
      verPrimeiraVez (hor) { 

        this.marcacao = hor.marcacao; 
        
        $('#novoPacienteModal').modal('show');

        if ( this.marcacao.paciente ) { // } && this.marcacao.fl_particular ) { 

          this.$util.load(this, { 
            service: 'marcacoes',
            func: 'show',
            parms: { 
              id: hor.marcacao.id_marcacao, 
              para_atendimento: true, 
            },
            loadTo: res => { 
              this.marcacao.paciente = res.paciente;

              if ( this.marcacao.procedimento.id_classe_procedimento == 17 
                && this.marcacao.paciente.atendimento_pacotes
                && this.marcacao.paciente.atendimento_pacotes.length ) { 

                this.marcacao.direto = true; 

              }
            }
          });

        }
        
      },
      verMarcar (hor) {  
        if( hor && hor.id_unidade_operacao ) { 

          this.refUnidOper = hor.id_unidade_operacao;
          
        } else { 

          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Unidade não identificada.",
            life: 5000
          });

          return;

        }

        this.$util.loadItem(this, { 
          service: 'medicos',
          id: this.medico_adm ? this.medico_adm : this.$store.state.user.id_pessoa,
          parms: { 
            marcar_consultorio: true,  
          }
        })
        .then(res => { 
          if ( !res )
            return;

          this.refHora = hor.hora;
          this.refHg = hor.hg;
          this.$refs.marcacao.reiniciar();
          $("#novoAtendimentoConsultorioModal").modal("show");

          this.$nextTick (() => { 
            this.$refs.marcacao.selecionarMedico(res);
          });
        });
      },

      abrir (atd) {
        $('[data-toggle="tooltip"]').tooltip('hide');
        this.$router.push({path: '/consultorio/' + atd.id_paciente});
      },
      abrirRes (atd) { 
        $('[data-toggle="tooltip"]').tooltip('hide');
        this.$router.push({path: '/consultorio/res/' + atd.id_atendimento});
      },
      load (refresh = false) { 

        if ( this.refresher ) { 
          clearInterval(this.refresher);
          this.refresher = null;
        }

        const recep = this.$util.recepcao();
        this.is_emergencia = ( recep && recep.fl_emergencia ) ? true : false;
      
        if ( refresh ) { 
          this.lista = [];
          this.outros = null;
        }

        this.$store.commit('loading', true);

        this.$store.commit(
          'setContexto', 
          { 
              medico_adm: this.medico_adm ? this.medico_adm : null,
          }
        );

        // let livres = this.viewMode == 'G' ? true : false;
        let livres = this.viewMode == 'C' ? false : true;
        let id_medico = this.medico_adm;
        let logado = true;

        if ( this.is_emergencia ) { 
          if ( this.viewMode == 'E' ) { 
            livres = false;
            id_medico = null; 
            logado = false;
          } else if ( this.viewMode == 'G' ) { 
            this.viewMode = 'A';
          }
        } else { 
          if ( this.viewMode == 'E' ) { 
            this.viewMode = 'A';
          }
        }

        //

        let alerta_chamar = false;

        if ( this.marcacoes && this.marcacoes.length && !this.marcacoes.find(hor => this.checkStatus(hor).status == 'chamar') ) { 
          alerta_chamar = true;
        }

        //

        const id_recep = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;
        const unid_oper = this.$util.unidade_operacao();

        this.te_max = this.$util.getCookie('te-max');
        
        let query = { 
          q: [
            { 
              name: "agendas.index",
              id: "lista",
              parms: {
                data: this.referencia,
                logado: ( this.ver_fila && id_medico ) ? false : logado,
                group: "none",
                livres: livres,
                status: this.viewMode == 'C' ? 'C' : 'T',
                consultorio: true, 
                id_medico: id_medico,
                local: this.$util.getCookie('local-chamada'), 
                id_recepcao: id_recep,
                recepcao: id_recep,
                unidade_operacao: unid_oper ? unid_oper.id_unidade_operacao : null, 
                conslivres: !livres || this.viewMode == 'A' ? false : true, 
              }
            },
            { 
              name: "atendimento_outros.index",
              id: "listaoutros",
              parms: {
                data: this.referencia,
                logado: true,
                consultorio: true, 
                id_medico: this.medico_adm,
                id_recepcao: this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null
              }
            },
            {
              name: "configuracoes.index",
              id: "atendepre",
              parms: { 
                where: { 
                  st_slug: 'atende-pre', 
                }, 
              },
            },
            {
              name: "configuracoes.index",
              id: "apuracao",
              parms: { 
                where: { 
                  st_slug: 'consultorio-apuracao-repasse', 
                }, 
                resource_id: 204, 
              },
            },
            {
              name: "configuracoes.index",
              id: "ymunity",
              parms: { 
                where: { 
                  st_slug: 'integracao-ymunity-clientid', 
                }, 
              },
            },
            {
              name: "tarefas.index",
              id: "tarefas",
              parms: { 
                pendentes: true, 
                minhas: this.medico_adm ? false : true, 
                id_medico: this.medico_adm, 
              },
            },
          ]
        };

        this.axios.post('/aql?a=agendas.index&m=cs', query)
          .then(res => { 
            console.log(res);
            if (res.data.atendepre.status == 200) {
              this.config_atende_pre = ( _.get(res.data.atendepre.data, '0.st_valor') == 1 ) ;
            }

            if (res.data.apuracao.status == 200) {
              this.config_apuracao_repasse = ( _.get(res.data.apuracao.data, '0.st_valor') == 1 ) ;
            }

            if ( res.data.lista.status == 200 ) { 
              this.marcacoes = res.data.lista.data.agendas;
              this.feriado = res.data.lista.data.feriado;
              this.bloqueio = res.data.lista.data.bloqueio;
              this.pode_atender = res.data.lista.data.direto;
              this.outros = res.data.listaoutros.data;
              this.tarefas = res.data.tarefas.data;
              this.filtrar ();

              if ( alerta_chamar && this.marcacoes.find(hor => this.checkStatus(hor).status == 'chamar') ) { 
                this.$toast.add({
                  severity: 'success',
                  summary: "Atenção",
                  detail: "Paciente disponível para chamada.",
                  life: 10000
                });

                this.beep();
              }
            }

            if (res.data.ymunity.status == 200) {
              this.integracao_ymunity = res.data.ymunity.data && res.data.ymunity.data.length && res.data.ymunity.data[0].st_valor ? true : false;
            }


          })
          .finally(() => {
            this.$store.commit('loading', false);

            if ( this.refresher ) { 
              clearInterval(this.refresher);
              this.refresher = null;
            }

            this.refresher = setInterval(() => {
              if ( $('.modal').is(':visible') ) { 
                // 
              } else if ( !this.$store.state.loading && this.$route.path == '/consultorio' ) { 
                if ( this.referencia == this.$util.hoje() ) { 
                  this.load(false);
                }
              }

              console.log('Refresh(C)', new Date().toISOString());
            }, 60000);
          });
      },

      setLocal () { 
        this.$util.setCookie('local-chamada', this.local, 365);
      },

      subscribe_recepcao() { 

        // Subscribe Channel
        subscribe(this.$store.state.dominio, "chamar-paciente", retorno => {

          if ( this.$route.path != '/consultorio' )
            return;
          
          let index = this.marcacoes.findIndex(item => {
            if ( retorno.data.id_marcacao ) { 
              return ( item.marcacao && item.marcacao.id_marcacao == retorno.data.id_marcacao );
            }
          });

          if ( retorno.data && retorno.data.msg && retorno.data.severity && !retorno.data.para_recepcao ) { 

            this.$toast.add({
                severity: retorno.data.severity,
                summary: "Atenção",
                detail: retorno.data.msg,
                life: 5000
              });

            this.load(false);
            return;

          }

          let refresh = false;

          if ( retorno.data.id_medico == this.$store.state.user.id_pessoa ) { 

            refresh = true;

          } else { 

            let recep = this.$util.getCookie('id_unidade_operacao') ? this.$util.getCookie('id_recepcao') : null;

            if ( recep == retorno.data.id_recepcao 
              && retorno.data.agenda_comp 
              && retorno.data.agenda_comp.find(ac => ac == this.$store.state.user.id_pessoa) ) { 

              refresh = true;

            }

          }

          if ( retorno.data.item_status ) { 

            if ( index && index >= 0 && retorno.data.id_atendimento && this.marcacoes[index].marcacao.id_atendimento == retorno.data.id_atendimento ) { 

              if ( !retorno.data.agenda_comp && retorno.data.id_medico != this.$store.state.user.id_pessoa ) { 

                this.marcacoes.splice(index, 1);

              } else { 

                this.marcacoes[index].marcacao.item_status = retorno.data.item_status;
                this.marcacoes[index].marcacao.sinalizador_atendimento = retorno.data.sinalizador;

                if ( retorno.data.atend_proc_laudos ) { 
                  this.marcacoes[index].marcacao.atend_proc_laudos = retorno.data.atend_proc_laudos;
                }

              }

              this.filtrar();

            } else { 
           
              if ( refresh ) { 
                this.load(false);
              }

            }

          }

        });

      },

      tour() { 
        window.scrollTo(0,0);

        // Define the tour!
        var tour = {
          id: "hello-hopscotch",
          i18n: { 
                  doneBtn: "Pronto",
                  nextBtn: "Próximo",
                  prevBtn: "Anterior",
                  skipBtn: "Pular"
              },
          steps: [
            {
              title: "Data de Atendimento",
              content: "Esse campo representa a data de atendimento. Você pode alterá-lo para consultar ateendimentos de dias anteriores, ou consultar agendas de dias seguintes.",
              target: "data-de-atendimento",
              placement: "bottom"
            },
            {
              title: "Pesquisar",
              content: "Realizar uma pesquisa a partir de um texto livre, como nome do paciente, procedimento ou operadora.",
              target: "filtro-pesquisar",
              placement: "bottom"
            },
            {
              title: "Imprimir",
              content: "Caso deseje realizar a impressão de sua agenda do dia, clique aqui.",
              target: "botao-de-imprimir",
              placement: "bottom"
            },
            {
              title: "Marcados vs Livres",
              content: "Nesses botões, é possível selecionar entre a visão que mostra apenas os pacientes marcados, ou a lista contendo também os horários livres disponíveis.",
              target: "botoes-de-visao",
              placement: "bottom"
            },
            {
              title: "Ação",
              content: "Nesse local, você terá o botão indicando o status atual do paciente, que pode estar Agendado, Na Recepção, Chamado, Em Atendimento, etc. Quando o botão estiver com a cor verde, escrito 'Chamar Paciente', indica que esse paciente está disponível para ser chamado. Ao clicar nesse botão um aviso de chamada é enviada para recepção e para o painel de chamada (quando esse estiver sendo utilizado). Irá então aparecer uma tela com o histórico do paciente, para que seja iniciado seu atendimento quando o paciente chegar no local.",
              target: "botao-acao",
              placement: "bottom"
            },
            {
              title: "Acesso ao Histórico do Paciente",
              content: "Clicando nessa figura, é possível consultar o histórico do paciente, caso se deseje consultar sem realizar a chamada do paciente para atendimento.",
              target: "acesso-perfil-paciente",
              placement: "left",
              yOffset: -10
            },
            {
              title: "Busca Livre de Paciente",
              content: "Caso se deseje consultar o histórico de um outro paciente, é possível utilizar esse campo para realizar a busca pelo nome ou CPF do paciente.",
              target: "autocomplete-paciente",
              placement: "bottom"
            },
            {
              title: "Identificação do Local de Atendimento",
              content: "Clique aqui para informar o nome do local de atendimento. Essa informação será enviada para recepção, quando da chamada de um paciente, para indicar a localização de encaminhamento.",
              target: "identificacao-local",
              placement: "left",
              yOffset: -20
            },
            {
              title: "Chat",
              content: "Clique aqui para visualizar os usuários que estão on-line no sistema, para envio de mensagens de comunicação interna.",
              target: "botao-chat",
              placement: "left",
              yOffset: -20
            },
          ]
        };

        window.hopscotch.startTour(tour);
      },

    },

    beforeMount() { 
        console.log('route', this.$route); 

        let flt = this.$util.getCookie('consultorio-proc-filtro');

        if ( flt ) { 
            this.filtrados = JSON.parse(flt);
        }

        let classe = this.$util.getCookie('consultorio-classe');
        this.classe = classe ? classe : 'T';

        let vmc = this.$util.getCookie('cns-cl-escopo');
        this.viewModeClasse = vmc ? vmc : 'A';

        let tipo_ordem = this.$util.getCookie('CS-ORD');
        this.tipo_ordem = tipo_ordem ? tipo_ordem : 'P';

        this.retracao['Atendidos'] = this.$util.getCookie('CS-Atendidos') == 1;
        this.retracao['Agendados'] = this.$util.getCookie('CS-Agendados') == 1;
        this.retracao['Faltosos'] = this.$util.getCookie('CS-Faltosos') == 1;

        this.faixa_hora = _.get(this.$store.state.contexto, 'consultorio_faixa_hora');

        let vm = this.$util.getCookie('cn-vm');
        this.viewMode = vm ? vm : 'A';

        //

        if ( this.ver_fila && this.id_medico_ver_fila ) { 

            this.medico_adm = this.id_medico_ver_fila;

            if ( this.fila_ref ) { 
                this.referencia = this.fila_ref;
            }

        } else { 

            let medico_adm = this.$store.state.contexto.medico_adm;

            if ( medico_adm ) { 
                this.medico_adm = medico_adm;
            }

            if ( this.$route.params && this.$route.params.dt ) { 
                this.referencia = this.$route.params.dt.slice(0,10);
            }

        }
    },

    beforeDestroy () { 
      EventBus.$off('refresh-local', this.refresh_local);

      if ( this.refresher ) { 
          clearInterval(this.refresher);
          this.refresher = null;
      }
    },

    
    mounted () { 
        if ( this.ver_fila ) { 

            this.load ();
            this.montando = false;

        } else { 

            this.agora = moment().format("YYYY-MM-DD HH:mm:ss");

            this.tmaInterval = setInterval(() => {
                this.agora = moment().format("YYYY-MM-DD HH:mm:ss");
            }, 1000 * 20);

            EventBus.$on('refresh-local', this.refresh_local);

            this.local = this.$util.getCookie('local-chamada');

            this.$store.commit('setBreadcrumb', 
                    [
                        { name: "Consultório", path: "/consultorio"}
                    ]);
                    
            this.load ();

            this.subscribe_recepcao();

            this.montando = false;

        }

    },

    destroyed() {
      if (this.tmaInterval) {
        clearInterval(this.tmaInterval);
        this.tmaInterval = null;
      }
    },

    updated () { 
      $('[data-toggle="tooltip"]').tooltip();
    }
}
</script>

<style scoped>

.painel { 
  position: absolute;
  overflow: auto;
  width: 300px;
  z-index: 1010;  
  padding: 0px;
}

.modal-dialog2 {
  width: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}

</style>
